import React from "react";
import { Header } from "semantic-ui-react";
import Logout from "../../components/Logout";
import classNames from "classnames";
import "./CardLayout.scss";

export default function CardLayout({
  className,
  title,
  children,
  logout = true,
}) {
  return (
    <>
      <div className={classNames("card-layout", className)}>
        <Header as="h1">{title}</Header>
        {children}
      </div>
      {logout ? (
        <div className="logout-wrapper">
          <Logout />
        </div>
      ) : null}
    </>
  );
}
